import { useDispatch, useSelector } from "react-redux"
import { useEffect, useMemo, useState } from "react"

import Button from "../../../common/Button"
import { servicesActions } from "../../../../store/services"

import classes from './../Shared/Filters.module.css'
import CustomSelect from "../../../common/interactive/CustomSelect"
import { atpProvidersOptions, nextgenDiagnosticServicesOptions, nextgenDiagnosticServicesOptionsSimple, nextgenReferralServicesOptions, nextgenReferralServicesOptionsSimple } from "../../../../lib/systemData"
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple"

const escapeRegex = (value) => {
    return `${value}`.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

const descriptionHasWholeWord = (description, word) => {
    if (!description || !word) {
        return false
    }
    const escapedWord = escapeRegex(word.trim())
    if (!escapedWord) {
        return false
    }

    // Match token only when surrounded by non-alpha chars (or string boundaries).
    const regex = new RegExp(`(^|[^a-zA-Z])${escapedWord}([^a-zA-Z]|$)`, "i")
    return regex.test(description)
}

const ServicesFilters = () => {
    const dispatch = useDispatch()

    
    const [selectedUser, setSelectedUser] = useState(null)
    
    const [classesOptions, setClassesOptions] = useState(null)
    const [selectedClass, setSelectedClass] = useState(null)
    
    const [selectedDiagnosticOrder, setSelectedDiagnosticOrder] = useState(nextgenDiagnosticServicesOptionsSimple())
    
    const [selectedReferralOrder, setSelectedReferralOrder] = useState(nextgenReferralServicesOptionsSimple())
    
    const activeCase = useSelector(state => state.case.activeCase)
    
    const services = useMemo(() => activeCase?.services ?? [], [activeCase?.services])
    const [allServices, setAllServices] = useState(services)

    useEffect(() => {

        const arr = [...services]

        if (arr) {
            let users = []
            arr.forEach(item => {
                if (users.length > 0) {
                    const index = users.findIndex(object => {
                        return object.value === item.order_by_id
                    })

                    if (index < 0) {
                        if (item.ordered_by_provider) {
                            users.push({
                                label: item.ordered_by_provider.first_name + ' ' + item.ordered_by_provider.last_name,
                                value: item.order_by_id
                            })
                        }
                        
                    }
                } else {
                    if (item.ordered_by_provider) {
                        users.push({
                            label: item.ordered_by_provider.first_name + ' ' + item.ordered_by_provider.last_name,
                            value: item.order_by_id
                        })
                    }
                    
                }
                
            })           
            
            let servicesClasses = []
            arr.forEach(item => {
                
                if (item.class) {
                    if (servicesClasses.length > 0) {
                        const index = servicesClasses.findIndex(object => {
                            return object.value === item.class
                        })
    
                        if (index < 0) {
                            servicesClasses.push({
                                label: item.class,
                                value: item.class
                            })
                        }
                    } else {
                        servicesClasses.push({
                            label: item.class,
                            value: item.class
                        })
                    }
                }
                
            })

            setClassesOptions(servicesClasses)
            
        }

    }, [services])


    const filterServicesOrderBy = (value) => {
        setSelectedUser(value.data.value)
 
        const arr = [...allServices]

        if (arr) {
            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.order_by_id === value.data.value)
            }
            if (selectedClass !== null) { //class
                results = results.filter(item => item.class === selectedClass)
            }
            

            dispatch(servicesActions.setFilterResult(results))
        }
        
    }

    const filterClasses = (value) => {
        setSelectedClass(value.data.value)
 
        const arr = [...allServices]

        if (arr) {

            let results = arr
            if (value.data.value) {
                results = arr.filter(item => item.class === value.data.value)
            }
            if (selectedUser !== null) { //document type
                results = results.filter(item => item.ordered_by_id === selectedUser)
            }            

            dispatch(servicesActions.setFilterResult(results))
        }
        
    }

    const clearFilters = () => {
        setSelectedUser(null)
        setSelectedClass(null)
        setSelectedDiagnosticOrder(['all'])
        setSelectedReferralOrder(['all'])
    }

    const filterDiagnosticOrders = (value) => {  
        if (value.data.value.includes('all') && value.data.value.indexOf('all') != 0) {
            setSelectedDiagnosticOrder(['all'])
        } else if (value.data.value.includes('all') && value.data.value.indexOf('all') == 0 && value.data.value.length == 1) {
            setSelectedDiagnosticOrder(['all'])
        } else {
            // Exclude the value 'all' from the array if present
            const values = Array.isArray(value.data.value)
                ? value.data.value.filter(v => v !== 'all')
                : value.data.value
            setSelectedDiagnosticOrder(values)
        }
    }

    const filterReferralOrders = (value) => {
        if (value.data.value.includes('all') && value.data.value.indexOf('all') != 0) {
            setSelectedReferralOrder(['all'])
        } else if (value.data.value.includes('all') && value.data.value.indexOf('all') == 0 && value.data.value.length == 1) {
            setSelectedReferralOrder(['all'])
        } else {
            // Exclude the value 'all' from the array if present
            const values = Array.isArray(value.data.value)
                ? value.data.value.filter(v => v !== 'all')
                : value.data.value
            setSelectedReferralOrder(values)
        }
        // setSelectedReferralOrder(value.data.value)
    }

    useEffect(() => {
        let filteredByDiagnosticOrders
        let filteredByReferralOrders
        if (selectedDiagnosticOrder && selectedDiagnosticOrder.length > 0) {
            if (selectedDiagnosticOrder.some(val => val === 'all')) {
                filteredByDiagnosticOrders = services.filter(item => item.class === 'DIAG')
            } else {
                filteredByDiagnosticOrders = services.filter(item => item.class === 'DIAG' && selectedDiagnosticOrder.some(val => 
                    descriptionHasWholeWord(item.description, val)
                ))
            }
            // filteredByDiagnosticOrders = [...allServices].filter(item => item.class == 'DIAG' && selectedDiagnosticOrder.some(val => 
            //     item.description && item.description.toLowerCase().includes(val.toLowerCase())
            // ))
        } else {
            // filteredByDiagnosticOrders = activeCase?.services.filter(item => item.class == 'DIAG')
            filteredByDiagnosticOrders = []
        }
        
        if (selectedReferralOrder && selectedReferralOrder.length > 0) {
            if (selectedReferralOrder.some(val => val === 'all')) {
                filteredByReferralOrders = services.filter(item => item.class !== 'DIAG')
            } else {
                filteredByReferralOrders = services.filter(item => item.class !== 'DIAG' && selectedReferralOrder.some(val => 
                    descriptionHasWholeWord(item.description, val)
                ))
            }
            // filteredByReferralOrders = [...allServices].filter(item => item.class != 'DIAG' && selectedReferralOrder.some(val => 
            //     item.description && item.description.toLowerCase().includes(val.toLowerCase())
            // ))
        } else {
            // filteredByReferralOrders = activeCase?.services.filter(item => item.class != 'DIAG')
            filteredByReferralOrders = []
        }


        const mergedUnique = [
            ...new Map(
              [...filteredByDiagnosticOrders, ...filteredByReferralOrders].map(item => [item.id, item])
            ).values(),
          ];
        // setAllServices([...filteredByDiagnosticOrders, ...filteredByReferralOrders])
        setAllServices(mergedUnique)
        dispatch(servicesActions.setFilterResult([...filteredByDiagnosticOrders, ...filteredByReferralOrders]))
    }, [selectedDiagnosticOrder, selectedReferralOrder, services, dispatch])

    return <div className={classes.container}>
        <span>Filters</span>
        <CustomSelect label={'Orderd by'} optionsData={atpProvidersOptions()} action={filterServicesOrderBy} preSelectedValue={selectedUser} hasRemove={true}/>
        <CustomSelect label={'Class'} optionsData={classesOptions} action={filterClasses} preSelectedValue={selectedClass} hasRemove={true}/>
        <CustomSelectMultiple label={'Diagnostic Orders'} optionsData={[...nextgenDiagnosticServicesOptions(), {label: 'All', value: 'all'}]} action={filterDiagnosticOrders} preSelectedValue={selectedDiagnosticOrder} hasRemove={true}/>
        <CustomSelectMultiple label={'Referral Orders'} optionsData={[...nextgenReferralServicesOptions(), {label: 'All', value: 'all'}]} action={filterReferralOrders} preSelectedValue={selectedReferralOrder} hasRemove={true}/>
        
        <Button click={clearFilters} btnStyle={'btn_grey'}>Clear</Button>
    </div>
}

export default ServicesFilters